export default __webpack_public_path__ + "static/media/red-1.7b561622.svg";